import { usePostApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdReminders } from '@fukuri-admins/apis/client/gen/endpoints';

export const usePostStressAssessmentReminders =
  usePostApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdReminders;
